<template>
  <div class="flex flex-col items-start justify-center">
    <div class="flex items-center gap-3">
      <button @click="$router.back()"><font-awesome-icon icon="fa-solid fa-arrow-left" /></button>
      <p class="text-sm text-white font-semibold">Edit Character</p>
    </div>
    <div class="flex flex-row gap-8 w-full relative mt-4 justify-between">
      <div class="flex flex-col gap-6">
        <SkinPreviewBox :item="gameStore.activeSkins['sword']" title="Sword"></SkinPreviewBox>
        <SkinPreviewBox :item="gameStore.activeSkins['hat']" title="Hat"></SkinPreviewBox>
        <SkinPreviewBox :item="gameStore.activeSkins['shirts']" title="Shirts"></SkinPreviewBox>
      </div>
      <div
        class="flex flex-col items-center justify-center w-9/12 mx-auto absolute m-auto left-0 right-0"
      >
        <PirateFigure :image="activeCharacter.image" blackShadow bigShadow class="!h-[240px] !w-full"></PirateFigure>
        <div class="z-10 rounded-full bg-PRIMARY font-semibold text-sm px-3 py-2 mt-2">
          {{ activeCharacter.name }}
        </div>
      </div>
      <div class="flex flex-col gap-6">
        <SkinPreviewBox :item="gameStore.activeSkins['pants']" title="Pants"></SkinPreviewBox>
        <SkinPreviewBox :item="gameStore.activeSkins['shoes']" title="Shoes"></SkinPreviewBox>
        <SkinPreviewBox :item="gameStore.activeSkins['belt']" title="Belt"></SkinPreviewBox>
      </div>
    </div>
    <div class="mt-28 w-full h-full ">
      <CharacterEditTabView v-model:model-value="activeTab"></CharacterEditTabView>
      <Transition name="slide-left" mode="out-in">
        <component :is="currentComponent" />
      </Transition>
    </div>
  </div>
</template>
<script setup>
import PirateFigure from '@/components/PirateFigure.vue'
import CharacterEditTabView from '@/components/CharacterEditTabView.vue'
import EditCharacterTab from '@/components/EditCharacterTabs/EditCharacterTab.vue'
import SkinTab from '@/components/EditCharacterTabs/SkinTab.vue'
import SkinPreviewBox from '@/components/SkinPreviewBox.vue'
import { useGameStore } from '@/stores/game'

import { ref, computed } from 'vue'

const tabList = ref([EditCharacterTab, SkinTab])
const activeTab = ref()
const gameStore = useGameStore()
const activeCharacter = gameStore.getActiveCharacter()

const currentComponent = computed(() => {
  return tabList.value[activeTab.value]
})
</script>
